module.exports = __webpack_public_path__ + "img/tg_24px.e15c2eea.svg";